import React from "react";
import {Link} from 'react-router-dom';
import * as Yup from "yup";
import {Formik, Field, ErrorMessage} from "formik";
import {errorMessage} from "../inputTypes";
import warning_img from '../../assets/images/warning-ic.svg';
import parse from "html-react-parser";

const countries = ["Andorra", "Antigua and Barbuda", "Afghanistan", "Anguilla", "Armenia", "Albania", "Angola", "American Samoa", "Argentina", "Australia", "Austria", "Aruba", "Bangladesh", "Belgium", "Burkina Faso", "Bulgaria", "Bosnia and Herzegovina", "Barbados", "Wallis and Futuna", "Saint Barthelemy", "Bermuda", "Brunei", "Bolivia", "Bahrain", "Burundi", "Benin", "Bhutan", "Jamaica", "Bouvet Island", "Botswana", "Samoa", "Bonaire, Saint Eustatius and Saba ", "Brazil", "Bahamas", "Jersey", "Belarus", "Belize", "Russia", "Rwanda", "Serbia", "East Timor", "Reunion", "Turkmenistan", "Tajikistan", "Romania", "Tokelau", "Guinea-Bissau", "Guam", "Guatemala", "South Georgia and the South Sandwich Islands", "Greece", "Equatorial Guinea", "Guadeloupe", "Japan", "Guyana", "Guernsey", "French Guiana", "Georgia", "Grenada", "Gabon", "El Salvador", "Guinea", "Gambia", "Greenland", "Gibraltar", "Ghana", "Oman", "Tunisia", "Jordan", "Croatia", "Haiti", "Hungary", "Hong Kong", "Honduras", "Heard Island and McDonald Islands", "Venezuela", "Puerto Rico", "Palestinian Territory", "Palau", "Portugal", "Svalbard and Jan Mayen", "Paraguay", "Iraq", "Panama", "French Polynesia", "Papua New Guinea", "Peru", "Pakistan", "Philippines", "Pitcairn", "Poland", "Saint Pierre and Miquelon", "Zambia", "Western Sahara", "Estonia", "Egypt", "South Africa", "Ecuador", "Italy", "Vietnam", "Solomon Islands", "Ethiopia", "Somalia", "Zimbabwe", "Saudi Arabia", "Spain", "Eritrea", "Montenegro", "Moldova", "Madagascar", "Saint Martin", "Morocco", "Monaco", "Uzbekistan", "Myanmar", "Mali", "Macao", "Mongolia", "Marshall Islands", "Macedonia", "Mauritius", "Malta", "Malawi", "Maldives", "Martinique", "Northern Mariana Islands", "Montserrat", "Mauritania", "Isle of Man", "Uganda", "Tanzania", "Malaysia", "Mexico", "Israel", "France", "British Indian Ocean Territory", "Saint Helena", "Finland", "Fiji", "Falkland Islands", "Micronesia", "Faroe Islands", "Nicaragua", "Netherlands", "Norway", "Namibia", "Vanuatu", "New Caledonia", "Niger", "Norfolk Island", "Nigeria", "New Zealand", "Nepal", "Nauru", "Niue", "Cook Islands", "Kosovo", "Ivory Coast", "Switzerland", "Colombia", "China", "Cameroon", "Chile", "Cocos Islands", "Canada", "Republic of the Congo", "Central African Republic", "Democratic Republic of the Congo", "Czech Republic", "Cyprus", "Christmas Island", "Costa Rica", "Curacao", "Cape Verde", "Cuba", "Swaziland", "Syria", "Sint Maarten", "Kyrgyzstan", "Kenya", "South Sudan", "Suriname", "U.S. Virgin Islands", "Iceland", "Iran", "Kiribati", "Cambodia", "Saint Kitts and Nevis", "Comoros", "Sao Tome and Principe", "Slovakia", "South Korea", "Slovenia", "North Korea", "Kuwait", "Senegal", "San Marino", "Sierra Leone", "Seychelles", "Kazakhstan", "Cayman Islands", "Singapore", "Sweden", "Sudan", "Dominican Republic", "Dominica", "Djibouti", "Denmark", "British Virgin Islands", "Germany", "Yemen", "Algeria", "United States", "Uruguay", "Mayotte", "United States Minor Outlying Islands", "Lebanon", "Saint Lucia", "Laos", "Tuvalu", "Taiwan", "Trinidad and Tobago", "Turkey", "Sri Lanka", "Liechtenstein", "Latvia", "Tonga", "Lithuania", "Luxembourg", "Liberia", "Lesotho", "Thailand", "French Southern Territories", "Togo", "Chad", "Turks and Caicos Islands", "Libya", "Vatican", "Saint Vincent and the Grenadines", "United Arab Emirates", "India", "Aland Islands", "Azerbaijan", "Ireland", "Indonesia", "Ukraine", "Qatar", "Mozambique"].sort();

// const trainingClinics = [
//     "Addenbrooke’s Hospital, Cambridge (Adults)",
//     "Addenbrooke’s Hospital, Cambridge (Paediatrics)",
//     "Alder Hey Children’s Hospital, Liverpool (Paediatrics)",
//     "Barts Hospital, London (Paediatrics)",
//     "Royal Derby Hospital, Derby (Adults)",
//     "Guy’s and St Thomas' Hospital, London (Adults)",
//     "Harrogate District Hospital, Harrogate (Adults)",
//     // "King’s College Hospital, London (Adults)",
//     // "King’s College Hospital, London (Paediatrics)",
//     "Leeds Children’s Hospital, Leeds (Paediatrics)",
//     "London Medical, London",
//     "Manchester Royal Infirmary, Manchester (Adults)",
//     "Nottingham Children's Hospital, Nottingham (Paediatrics)",
//     "Derriford Hospital, Plymouth (Adults) ",
//     "Southampton Children’s Hospital, Southampton (Paediatrics)",
//     "East Surrey Hospital, Guildford (Adults)"
// ].sort();

const trainingClinics = [].sort();

let infoOrigin = [
    "Clinic",
    "Search engine",
    "Social media",
    "A post from a friend on social media",
    "JDRF",
    "Diabetes UK",
    "Radio",
    "TV",
    "Print",
    "Word of mouth",
    "Other"];

const StepTwoForm = (props) => {
    const initialValues = props.initialValues;
    infoOrigin = props.orderPageText.s3InfoSource;

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={stepTwoValidationSchema(props)}
                validateOnBlur={true}
                validateOnChange={true}
                onSubmit={(values, tag) => console.log(values, 'asasaas')}
            >
                {({values, setFieldTouched, setFieldValue, isValid, errors}) => (
                    <form>
                        <section className="step-chart-content">
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <div className="step-content-row step-content-row-field">
                                            <div className="step-content-left">
                                                <p>{parse(props.orderPageText.s3TeritoryQuestion)}</p>
                                                {values.unitedKingdom === "false" && notFromUnitedForm(values, isValid, props, errors, setFieldValue)}
                                            </div>
                                            <div className="step-content-right">
                                                <div className="custom-radio">
                                                    <input
                                                        type="radio"
                                                        name="unitedKingdom"
                                                        id="stage_btn7"
                                                        value="true"
                                                        checked={props.initialValues.unitedKingdom === "true" ? "checked" : ""}
                                                        onChange={(e) => {
                                                            const selectedValue = e.target.value;
                                                            setTimeout(async () => {
                                                                props.initialValues.unitedKingdom = selectedValue;
                                                                await setFieldValue(
                                                                    "unitedKingdom",
                                                                    selectedValue
                                                                );
                                                                await setFieldTouched("unitedKingdom", true);
                                                            });
                                                        }}
                                                    />
                                                    <label htmlFor="stage_btn7">
                                                        {parse(props.orderPageText.s2Yes)}
                                                    </label>
                                                </div>
                                                <div className="custom-radio">
                                                    <input type="radio" name="unitedKingdom" id="stage_btn8"
                                                           value="false"
                                                           checked={props.initialValues.unitedKingdom === "false" ? "checked" : ""}
                                                           onChange={(e) => {
                                                               const selectedValue = e.target.value;
                                                               setTimeout(async () => {
                                                                   props.initialValues.unitedKingdom = selectedValue;
                                                                   await setFieldValue(
                                                                       "unitedKingdom",
                                                                       selectedValue
                                                                   );
                                                                   await setFieldValue(
                                                                       "training",
                                                                       ""
                                                                   );
                                                                   await setFieldTouched("unitedKingdom", true);
                                                               });
                                                           }}
                                                    />
                                                    <label htmlFor="stage_btn8" className="red-border">
                                                        {parse(props.orderPageText.s2No)}
                                                    </label>
                                                </div>
                                                {
                                                    values.unitedKingdom === "false" && (
                                                        <div className="div-content bottom-para">
                                                            <p>{parse(props.orderPageText.s3NotAvailable)}</p>
                                                            <p className="bottom-para-p">
                                                                {parse(props.orderPageText.s3TC1)} {' '}
                                                                <Link
                                                                    to={props.prefix + "/terms"}>
                                                                    {parse(props.orderPageText.s3TC2)}</Link>
                                                                {' '}{parse(props.orderPageText.s3TC3)}{' '} <Link
                                                                to="/privacy">{parse(props.orderPageText.s3TC4)}
                                                            </Link>{' '}
                                                                {parse(props.orderPageText.s3TC5)}</p>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div
                                            style={{position: values.unitedKingdom === "" || values.unitedKingdom === "false" ? "relative" : "initial"}}>
                                            <div
                                                className={`step-content-row ${values.unitedKingdom === "" ||
                                                values.unitedKingdom === "false" ? "disable-div" : ""}`}>
                                                <div className="step-content-left">
                                                    <p>{parse(props.orderPageText.s3Training1)}
                                                        {' '}<Link
                                                            to={props.prefix + "/user-training"}>
                                                            {parse(props.orderPageText.s3Training2)}
                                                        </Link>{' '}
                                                        {parse(props.orderPageText.s3Training3)} </p>
                                                    <p>{parse(props.orderPageText.s3TrainingCdep1)}</p>
                                                    <select name="training" onChange={(e) => {
                                                        setFieldValue("training", e.target.value)
                                                    }} value={values.training}
                                                            className={`form-field ${values.training !== "" ? 'value-exist' : 'value-not-exist'}`}>
                                                        <option
                                                            value="">{parse(props.orderPageText.s3TrainingCdep2)}</option>
                                                        {/*<option value="none">None</option>*/}
                                                        {
                                                            trainingClinics.map(c => {
                                                                return (<option value={c}>{c}</option>)
                                                            })
                                                        }
                                                        <option value={props.orderPageText.s3TrainingCdep3}>
                                                            {parse(props.orderPageText.s3TrainingCdep3)}
                                                        </option>
                                                        {/*<option value="Not listed">Not listed</option>*/}
                                                    </select>
                                                    {
                                                        values.training === "none" && noTrainingForm(values, isValid, props, errors)
                                                    }
                                                </div>
                                                {
                                                    values.training === "none" && <div className="step-content-right">
                                                        <div className="div-content bottom-para div-content-other">
                                                            <p>Please fill in your details if you would like us to
                                                                contact you about organising training by a certified
                                                                trainer.
                                                                This may incur cost.</p>
                                                            <p className="bottom-para-p">By submitting your request you
                                                                agree to our
                                                                <Link to={props.prefix + "/terms"}>
                                                                    T&Cs</Link> and
                                                                <Link
                                                                    to={props.prefix + "/privacy"}>
                                                                    Privacy</Link> and allow us
                                                                to contact you.</p>
                                                        </div>
                                                    </div>
                                                }
                                                {/* <div className="step-content-right">
                                                </div> */}
                                            </div>
                                            {
                                                yesTrainingForm(props, values, setFieldTouched, setFieldValue, (values.training === "" || values.training === "none"), errors)
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <div className="next-step">
                                            <button className="btn arrow-btn prev-btn"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        props.handlePrevious(values)
                                                    }}>
                                                {parse(props.orderPageText.previous)}
                                            </button>
                                            <button className={`btn arrow-btn ${
                                                Object.keys(errors).length > 0
                                                || (values.unitedKingdom === "false" || values.unitedKingdom === "")
                                                || (values.training === "false" || values.training === "none")
                                                || (values.serial1 === "")
                                                || (values.exemptVat === "") ? 'disable-btn' : ''}`}
                                                    type="submit"
                                                    disabled={Object.keys(errors).length > 0
                                                    || (values.unitedKingdom === "false" || values.unitedKingdom === "")
                                                    || (values.training === "false" || values.training === "none")
                                                    || (values.serial1 === "")
                                                    || (values.exemptVat === "")}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        props.handleSubmit(values, 'others')
                                                    }}>
                                                {parse(props.orderPageText.next)}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </form>
                )}
            </Formik>
        </div>
    );
};


/**
 * notFromUnitedForm method is used to return form when user select no
 * @param {*} values
 */
const notFromUnitedForm = (values, isValid, props, errors, setFieldValue) => {
    return (
        <>

            <select name="notFromUnitedFormCountry" onChange={(e) => {
                setFieldValue("notFromUnitedFormCountry", e.target.value)
            }} value={values.notFromUnitedFormCountry}
                    className={`form-field ${values.notFromUnitedFormCountry !== "" ?
                        'value-exist' : 'value-not-exist'}`}>
                <option value="">{parse(props.orderPageText.s3SelectCountry)}</option>
                {
                    countries.map(c => {
                        return (<option value={c}>{c}</option>)
                    })
                }
            </select>
            <div
                className={`form-field ${values.notFromUnitedFormFirstName !== "" ? 'value-exist' : 'value-not-exist'}`}>
                <Field
                    type="text"
                    placeholder={props.orderPageText.s3FirstName}
                    name="notFromUnitedFormFirstName"
                    value={values.notFromUnitedFormFirstName}
                />
                <ErrorMessage name="notFromUnitedFormFirstName" component={errorMessage}/>
            </div>
            <div
                className={`form-field ${values.notFromUnitedFormLastName !== "" ? 'value-exist' : 'value-not-exist'}`}>
                <Field
                    type="text"
                    placeholder={props.orderPageText.s3LastName}
                    name="notFromUnitedFormLastName"
                    value={values.notFromUnitedFormLastName}
                />
                <ErrorMessage name="notFromUnitedFormLastName" component={errorMessage}/>

            </div>
            <div className={`form-field ${values.notFromUnitedFormEmail !== "" ? 'value-exist' : 'value-not-exist'}`}>
                <Field
                    type="text"
                    placeholder={props.orderPageText.s3Email}
                    name="notFromUnitedFormEmail"
                    value={values.notFromUnitedFormEmail}
                />
                <ErrorMessage name="notFromUnitedFormEmail" component={errorMessage}/>
            </div>
            <div
                className={`form-field ${values.notFromUnitedFormConfirmEmail !== "" ?
                    (errors.notFromUnitedFormConfirmEmail ? 'invalid-serial' : 'value-exist') : 'value-not-exist'}`}>
                <Field
                    type="text"
                    placeholder={props.orderPageText.s3EmailConfirm}
                    name="notFromUnitedFormConfirmEmail"
                    value={values.notFromUnitedFormConfirmEmail}
                />
                <ErrorMessage name="notFromUnitedFormConfirmEmail" component={errorMessage}/>
            </div>
            {/* {console.log(errors)} */}
            <button type="button" className={`btn small ${!isValid ? 'disable-btn' : ''}`} disabled={!isValid}
                    onClick={() => props.handleSubmit(values, "notFromUnitedForm")}>{props.orderPageText.s3SubmitCountry}
            </button>

        </>
    )
};

/**
 * noTrainingForm method is used to render form when user select none from select option
 * @param {*} values
 */
const noTrainingForm = (values, isValid, props, errors) => {
    return (
        <>
            <div
                className={`form-field ${values.noneTrainingFormFirstName !== "" ? 'value-exist' : 'value-not-exist'}`}>
                <Field
                    type="text"
                    placeholder={props.orderPageText.s3FirstName}
                    name="noneTrainingFormFirstName"
                    value={values.noneTrainingFormFirstName}
                />
                <ErrorMessage name="noneTrainingFormFirstName" component={errorMessage}/>
            </div>
            <div className={`form-field ${values.noneTrainingFormLastName !== "" ? 'value-exist' : 'value-not-exist'}`}>
                <Field
                    type="text"
                    placeholder={props.orderPageText.s3LastName}
                    name="noneTrainingFormLastName"
                    value={values.noneTrainingFormLastName}
                />
                <ErrorMessage name="noneTrainingFormLastName" component={errorMessage}/>
            </div>
            <div className={`form-field ${values.noneTrainingFormEmail !== "" ? 'value-exist' : 'value-not-exist'}`}>
                <Field
                    type="text"
                    placeholder={props.orderPageText.s3Email}
                    name="noneTrainingFormEmail"
                    value={values.noneTrainingFormEmail}
                />
                <ErrorMessage name="noneTrainingFormEmail" component={errorMessage}/>
            </div>
            <div
                className={`form-field ${values.noneTrainingFormConfirmEmail !== "" ? (errors.noneTrainingFormConfirmEmail ? 'invalid-serial' : 'value-exist') : 'value-not-exist'}`}>
                <Field
                    type="text"
                    placeholder={props.orderPageText.s3EmailConfirm}
                    name="noneTrainingFormConfirmEmail"
                    value={values.noneTrainingFormConfirmEmail}
                />
                <ErrorMessage name="noneTrainingFormConfirmEmail" component={errorMessage}/>
                {
                }
            </div>
            <button type="button"
                    className={`btn small ${(errors.noneTrainingFormFirstName || errors.noneTrainingFormLastName || errors.noneTrainingFormEmail || errors.noneTrainingFormConfirmEmail) ? 'disable-btn' : ''}`}
                    disabled={(errors.noneTrainingFormFirstName || errors.noneTrainingFormLastName || errors.noneTrainingFormEmail || errors.noneTrainingFormConfirmEmail)}
                    onClick={() => props.handleSubmit(values, "noneTrainingForm")}>submit
            </button>
        </>
    )
};

/**
 * yesTrainingForm method is used to return further step
 * @param {*} values
 */
const yesTrainingForm = (props, values, setFieldTouched, setFieldValue, disable, errors) => {
    return (
        <div style={{position: disable ? "relative" : "initial"}} className={`${disable ? "disable-div" : ""}`}>
            {/* <div className={`${disable ? "disable-CampAss" : ""}`}></div> */}
            <div className={`step-content-row`}>
                <div className="step-content-left">
                    <p>{parse(props.orderPageText.s3contactHeading)}</p>
                    {
                        values.camAPSUserExist === "true" && camApsUserExistForm(values, errors, props)
                    }
                    {
                        camApsUserExistForm(values, errors, props)
                    }
                </div>
            </div>
            <div className="step-content-row">
                <div className="step-content-left">
                    <p>{parse(props.orderPageText.s3whereHeard)}</p>
                    <select name="referrence" onChange={(e) =>
                        setFieldValue("referrence", e.target.value)}
                            className={`form-field ${values.referrence !== "" ? 'value-exist' : 'value-not-exist'}`}>
                        <option value="">{parse(props.orderPageText.s3whereHeardSelect)}</option>
                        {
                            infoOrigin.map(c => {
                                return (<option value={c}>{c}</option>)
                            })
                        }
                    </select>
                </div>
                <div className="step-content-right"></div>
            </div>
            <div className="step-content-row">
                <div className="step-content-left">
                    <p>{parse(props.orderPageText.s3pumpSerialNumber)}</p>
                    <div
                        className={`three-text-box ${(values.serial1 !== "") ?
                            ((errors.serial1) ? 'invalid-serial' : 'value-exist') : 'value-not-exist'}`}>
                        <div className="form-field">
                            <Field type="text" placeholder="XXX00000XX" name="serial1"/>
                            {/*<ErrorMessage name="serial1" component={errorMessage} />*/}
                        </div>

                    </div>
                    <p>{parse(props.orderPageText.s3pumpSerialNumberConfirm)}</p>
                    <div
                        className={`three-text-box ${(values.confirmSerial1 !== "") ?
                            ((errors.confirmSerial1) ? 'invalid-serial' : 'value-exist') : 'value-not-exist'}`}>
                        <div className="form-field">
                            <Field type="text"
                                   placeholder="XXX00000XX"
                                   name="confirmSerial1"/>
                            {/* <ErrorMessage name="confirmSerial1" component={errorMessage} /> */}
                        </div>

                    </div>
                </div>
                <div className="step-content-right">
                    <div className="warning-div warning-div-para">
                        <img src={warning_img} alt="warning-img"/>
                        <p><span>{parse(props.orderPageText.s3pumpSerialNumberMessage)}</span>&nbsp;
                            {parse(props.orderPageText.s3pumpSerialNumberMessage1)}</p>
                    </div>
                </div>
            </div>
            <div className="step-content-row">
                <div className="step-content-left">
                    <p>{parse(props.orderPageText.s3vatExempt)}</p>
                    {
                        values.exemptVat === "true" && exempFromVatTrue(values, props)
                    }
                </div>
                <div className="step-content-right">
                    <div className="custom-radio">
                        <input type="radio" name="exemptVat" id="stage_btn11" value="true"
                               checked={props.initialValues.exemptVat === "true" ? "checked" : ""}
                               onChange={(e) => {
                                   const selectedValue = e.target.value;
                                   setTimeout(async () => {
                                       props.initialValues.exemptVat = selectedValue;
                                       await setFieldValue(
                                           "exemptVat",
                                           selectedValue
                                       );
                                       await setFieldTouched("exemptVat", true);
                                   });
                               }}/>
                        <label htmlFor="stage_btn11">
                            {parse(props.orderPageText.s2Yes)}
                        </label>
                    </div>
                    <div className="custom-radio">
                        <input type="radio" name="exemptVat" id="stage_btn12" value="false"
                               checked={props.initialValues.exemptVat === "false" ? "checked" : ""}
                               onChange={(e) => {
                                   const selectedValue = e.target.value;
                                   setTimeout(async () => {
                                       props.initialValues.exemptVat = selectedValue;
                                       await setFieldValue(
                                           "exemptVat",
                                           selectedValue
                                       );
                                       await setFieldTouched("exemptVat", true);
                                   });
                               }}/>
                        <label htmlFor="stage_btn12" className="red-border">
                            {parse(props.orderPageText.s2No)}
                        </label>
                    </div>
                    <div className="step-inner-content">
                        <p>{parse(props.orderPageText.s3vatHelp1)}&nbsp;
                            <a
                                href={props.orderPageText.s3vatHelpHtml}
                                title={props.orderPageText.s3vatHelpLine}
                                target="_blank" rel="noopener noreferrer">
                                {parse(props.orderPageText.s3vatHelp2)}</a>
                            &nbsp;{parse(props.orderPageText.s3vatHelp3)}</p>

                        <p>{parse(props.orderPageText.s3vatHelp4)}</p>
                        <div className="warning-div warning-div-para">
                            <img src={warning_img} alt="warning-img"/>
                            <p><span>{parse(props.orderPageText.s3vatHelp5)}</span>&nbsp;
                                {parse(props.orderPageText.s3vatHelp6)}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

/**
 * camApsUserExistForm method returns form when user select yes that he is from camAps
 * @param {*} values
 */
const camApsUserExistForm = (values, errors, props) => {
    return (
        <>
            <div className="form-field-wrapper">
                <div
                    className={`form-field ${values.camAPSUserFormFirstName !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3FirstName}
                        name="camAPSUserFormFirstName"
                        value={values.camAPSUserFormFirstName}
                    />
                    <ErrorMessage name="camAPSUserFormFirstName" component={errorMessage}/>

                </div>
                <div
                    className={`form-field ${values.camAPSUserFormLastName !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3LastName}
                        name="camAPSUserFormLastName"
                        value={values.camAPSUserFormLastName}
                    />
                    <ErrorMessage name="camAPSUserFormLastName" component={errorMessage}/>
                </div>
                <div className={`form-field ${values.camAPSUserFormEmail !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3Email}
                        name="camAPSUserFormEmail"
                        value={values.camAPSUserFormEmail}
                    />
                    <ErrorMessage name="camAPSUserFormEmail" component={errorMessage}/>
                </div>
                <div
                    className={`form-field ${values.camAPSUserFormConfirmEmail !== "" ? (errors.camAPSUserFormConfirmEmail ? 'invalid-serial' : 'value-exist') : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3EmailConfirm}
                        name="camAPSUserFormConfirmEmail"
                        value={values.camAPSUserFormConfirmEmail}
                    />
                    <ErrorMessage name="camAPSUserFormConfirmEmail" component={errorMessage}/>

                </div>
            </div>
        </>
    )
};

/**
 * exempt From Vat method is used to return form when user select yes
 * @param {*} values
 */
const exempFromVatTrue = (values, props) => {
    return (
        <>
            <div className="vat-form">
                <div
                    className={`form-field ${values.exemptVatFormFirstName !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3FirstName}
                        name="exemptVatFormFirstName"
                        value={values.exemptVatFormFirstName}
                    />
                    <ErrorMessage name="exemptVatFormFirstName" component={errorMessage}/>
                </div>
                <div
                    className={`form-field ${values.exemptVatFormLastName !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3LastName}
                        name="exemptVatFormLastName"
                        value={values.exemptVatFormLastName}
                    />
                    <ErrorMessage name="exemptVatFormLastName" component={errorMessage}/>
                </div>
                <div
                    className={`form-field ${values.exemptVatFormAddress1 !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3AddressLine1}
                        name="exemptVatFormAddress1"
                        value={values.exemptVatFormAddress1}
                    />
                    <ErrorMessage name="exemptVatFormAddress1" component={errorMessage}/>
                </div>
                <div
                    className={`form-field ${values.exemptVatFormAddress2 !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3AddressLine2}
                        name="exemptVatFormAddress2"
                        value={values.exemptVatFormAddress2}
                    />
                    <ErrorMessage name="exemptVatFormAddress2" component={errorMessage}/>
                </div>
                <div
                    className={`form-field ${values.exemptVatFormAddress3 !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3AddressLine3}
                        name="exemptVatFormAddress3"
                        value={values.exemptVatFormAddress3}
                    />
                    <ErrorMessage name="exemptVatFormAddress3" component={errorMessage}/>
                </div>
                <div
                    className={`form-field half_width ${values.exemptVatFormPostalCode !== "" ? 'value-exist' : 'value-not-exist'}`}>
                    <Field
                        type="text"
                        placeholder={props.orderPageText.s3PostCode}
                        name="exemptVatFormPostalCode"
                        value={values.exemptVatFormPostalCode}
                    />
                    <ErrorMessage name="exemptVatFormPostalCode" component={errorMessage}/>
                </div>
            </div>
            <div className="vat-form">
                <p>{parse(props.orderPageText.s3DisabilityHeading)}</p>
                <div className={`form-field ${values.sickness !== "" ? 'value-exist' : ''}`}>
                    <Field type="text"
                           placeholder={props.orderPageText.s3Disability}
                           name="sickness"/>
                    <ErrorMessage name="sickness" component={errorMessage}/>
                </div>
                <div className={`form-field ${values.signature !== "" ? 'value-exist' : ''}`}>
                    <Field type="text"
                           placeholder={props.orderPageText.s3signature}
                           name="signature"/>
                    <ErrorMessage name="signature" component={errorMessage}/>
                </div>

                {/*<div*/}
                {/*    className={`three-text-box ${(values.day !== "" && values.month !== "" && values.year !== "") ? 'value-exist' : ''}`}>*/}
                {/*    <div className={`form-field`}>*/}
                {/*        <Field type="text" placeholder="DAY" name="day"/>*/}
                {/*        <ErrorMessage name="day" component={errorMessage}/>*/}
                {/*    </div>*/}
                {/*    <div className={`form-field`}>*/}
                {/*        <Field type="text" placeholder="MONTH" name="month"/>*/}
                {/*        <ErrorMessage name="month" component={errorMessage}/>*/}
                {/*    </div>*/}
                {/*    <div className={`form-field`}>*/}
                {/*        <Field type="text" placeholder="YEAR" name="year"/>*/}
                {/*        <ErrorMessage name="year" component={errorMessage}/>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </>
    )
};

/**
 * equalTo method is used to add equal compare method
 * @param {*} ref
 * @param {*} msg
 */
const equalTo = (ref, msg) => {
    return Yup.mixed().test({
        name: 'equalTo',
        exclusive: false,
        // eslint-disable-next-line no-template-curly-in-string
        message: msg || '${path} must be the same as ${reference}',
        params: {
            reference: ref.path,
        },
        test: function (value) {
            return value === this.resolve(ref);
        },
    });
};

Yup.addMethod(Yup.string, 'equalTo', equalTo);

/**
 * stepTwoValidationSchema method is used to validate step two form
 */
const stepTwoValidationSchema = (props) => Yup.object().shape({

    /**
     * this validates when user select no, that he is not from united kingdom
     */
    unitedKingdom: Yup.boolean().oneOf(
        [true, false],
        props.orderPageText.s3PhoneWarning
    ).required().nullable(false),
    notFromUnitedFormFirstName: Yup.string().when("unitedKingdom", {
        is: false,
        then: Yup.string()
            .required(props.orderPageText.s3NameMissing)
            .trim()
    }).nullable(true),
    notFromUnitedFormLastName: Yup.string().when("unitedKingdom", {
        is: false,
        then: Yup.string()
            .required(props.orderPageText.s3SurnameRequired)
            .trim()
    }).nullable(true),
    notFromUnitedFormEmail: Yup.string().when("unitedKingdom", {
        is: false,
        then: Yup.string()
            .required(props.orderPageText.s3EmailRequired)
            .trim()
    }).nullable(true),
    notFromUnitedFormCountry: Yup.string().when("unitedKingdom", {
        is: false,
        then: Yup.string()
            .required(props.orderPageText.s3CountryRequired)
            .trim()
    }).nullable(true),
    notFromUnitedFormConfirmEmail: Yup.string().when("unitedKingdom", {
        is: false,
        then: Yup.string()
            .required(props.orderPageText.s3EmailConfimrRequired)
            .trim()
    }).equalTo(Yup.ref('notFromUnitedFormEmail'), props.orderPageText.s3EmailMatchRequired).nullable(true),

    /**
     *  this is used to validate when user select none from training clinic
     */
    training: Yup.string().when("unitedKingdom", {
        is: true,
        then: Yup.string()
            .required(props.orderPageText.s3ClinicRequired)
            .trim()
    }).nullable(true),
    noneTrainingFormFirstName: Yup.string().when("training", {
        is: "none",
        then: Yup.string()
            .required(props.orderPageText.s3NameMissing)
            .trim()
    }).nullable(true),
    noneTrainingFormLastName: Yup.string().when("training", {
        is: "none",
        then: Yup.string()
            .required(props.orderPageText.s3SurnameRequired)
            .trim()
    }).nullable(true),
    noneTrainingFormEmail: Yup.string().when("training", {
        is: "none",
        then: Yup.string()
            .required(props.orderPageText.s3EmailRequired)
            .trim()
    }).nullable(true),
    noneTrainingFormConfirmEmail: Yup.string().when("training", {
        is: "none",
        then: Yup.string()
            .required(props.orderPageText.s3EmailConfimrRequired)
            .trim()
    }).equalTo(Yup.ref('noneTrainingFormEmail'), props.orderPageText.s3EmailMatchRequired).nullable(true),

    /**
     * this validates when user selects that he is user of camAPS
     */
    camAPSUserExist: Yup.boolean().when("unitedKingdom", {
        is: true,
        then: Yup.boolean().oneOf(
            [true, false],
            props.orderPageText.s3DiseaseStateRequired),
    }).when("training", {
        is: "none",
        then: Yup.boolean().nullable(true),
    }).nullable(true),
    camAPSUserFormFirstName: Yup.string().when("unitedKingdom", {
        is: true,
        then: Yup.string().required(props.orderPageText.s3NameMissing),
        otherwise: Yup.string().nullable(true)
    }).nullable(true),
    camAPSUserFormLastName: Yup.string().when("unitedKingdom", {
        is: true,
        then: Yup.string().required(props.orderPageText.s3SurnameRequired),
        otherwise: Yup.string().nullable(true)
    }).nullable(true),
    camAPSUserFormEmail: Yup.string().when("unitedKingdom", {
        is: true,
        then: Yup.string().required(props.orderPageText.s3EmailRequired),
        otherwise: Yup.string().nullable(true)
    }).nullable(true),
    // camAPSUserFormConfirmEmail: Yup.string().when("camAPSUserExist", {
    //     is: true,
    //     then: Yup.string().required('Confirm Email is required'),
    //     otherwise: Yup.string().nullable(true)
    // }).nullable(true),
    camAPSUserFormConfirmEmail: Yup.string().equalTo(Yup.ref('camAPSUserFormEmail'),
        props.orderPageText.s3EmailMatchRequired).nullable(true),
    reference: Yup.string().trim(),

    serial1: Yup.string().matches(/[A-Z]{3}\d{5}[A-Z]{2}/, props.orderPageText.s3OnlyTextValueProvided).when('training', {
        is: !"none",
        then: Yup.string().nullable(true)
    }).when('unitedKingdom', {
        is: false,
        then: Yup.string().nullable(true)
    }).nullable(true),
    serial2: Yup.string().matches(/^[0-9]*$/, props.orderPageText.s3OnlyNumberValueProvided).nullable(true),
    serial3: Yup.string().matches(/[a-zA-Z]+/, props.orderPageText.s3OnlyTextValueProvided).trim().nullable(true),
    confirmSerial1: Yup.string().equalTo(Yup.ref('serial1'), props.orderPageText.s3SerialNumbersMatch),
    confirmSerial2: Yup.string().matches(/^[0-9]*$/, props.orderPageText.s3OnlyNumberValueProvided).equalTo(Yup.ref('serial2'), 'serial number must match'),
    confirmSerial3: Yup.string().equalTo(Yup.ref('serial3'), props.orderPageText.s3SerialNumbersMatch),
    /**
     * exemptVat is used to validate that selecting yes or not from vat
     */
    exemptVat: Yup.boolean().when("unitedKingdom", {
        is: true,
        then: Yup.boolean().when("training", {
            is: "none",
            then: Yup.boolean()
                .nullable(false)
        }).oneOf(
            [true, false],
            props.orderPageText.s3vatStatusRequired
        ),
    }),
    exemptVatFormFirstName: Yup.string().when("exemptVat", {
        is: true,
        then: Yup.string()
            .required(props.orderPageText.s3NameMissing)
            .trim()
    }).nullable(true),
    exemptVatFormLastName: Yup.string().when("exemptVat", {
        is: true,
        then: Yup.string()
            .required(props.orderPageText.s3SurnameRequired)
            .trim()
    }).nullable(true),
    exemptVatFormAddress1: Yup.string().when("exemptVat", {
        is: true,
        then: Yup.string()
            .required(props.orderPageText.s3AddressLine1Required)
            .trim()
    }).nullable(true),
    exemptVatFormAddress2: Yup.string().when("exemptVat", {
        is: true,
        then: Yup.string()
            .required(props.orderPageText.s3AddressLine2Required)
            .trim()
    }).nullable(true),
    // exemptVatFormAddress3: Yup.string().when("exemptVat", {
    //     is: true,
    //     then: Yup.string()
    //         .required('Address Line Three is required')
    //         .trim()
    // }).nullable(true),
    exemptVatFormPostalCode: Yup.string().when("exemptVat", {
        is: true,
        then: Yup.string()
            .required(props.orderPageText.s3PostCodeRequired)
            .trim()
    }).nullable(true),
    sickness: Yup.string().when("exemptVat", {
        is: true,
        then: Yup.string()
            .required(props.orderPageText.s3SickessRequired)
            .trim()
    }).nullable(true),
    signature: Yup.string().when("exemptVat", {
        is: true,
        then: Yup.string()
            .required(props.orderPageText.s3SignatureRequired)
            .trim()
    }).nullable(true),
    // day: Yup.string().when("exemptVat", {
    //     is: true,
    //     then: Yup.string()
    //         .required('Day is required')
    //         .trim()
    // }).nullable(true),
    // month: Yup.string().when("exemptVat", {
    //     is: true,
    //     then: Yup.string()
    //         .required('month  is required')
    //         .trim()
    // }).nullable(true),
    // year: Yup.string().when("exemptVat", {
    //     is: true,
    //     then: Yup.string()
    //         .required('year is required')
    //         .trim()
    // }).nullable(true),
});

export default StepTwoForm;
